import { LoadingButton } from '@mui/lab'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField } from '@mui/material'
import { CompanyRegisteredImporterDto, companyRegisteredImporterValidationSchema } from 'dtos'
import { Formik } from 'formik'
import { ExplanationAccordion } from 'components'

interface RegisteredImporterAddEditDialogProps {
  initialValues: CompanyRegisteredImporterDto
  loading: boolean
  onClose: () => void
  onSave: (values: any) => void
  open: boolean
}

export default function RegisteredImporterAddEditDialog({
  initialValues,
  loading,
  onClose,
  onSave,
  open
}: RegisteredImporterAddEditDialogProps) {
  return (
    <Dialog open={open}>
      <Formik
        enableReinitialize={true}
        initialValues={initialValues}
        validateOnChange={true}
        validateOnBlur={true}
        validationSchema={companyRegisteredImporterValidationSchema}
        onSubmit={(values, formikHelpers) => {
          onSave(values)
          formikHelpers.setSubmitting(false)
        }}
      >
        {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, touched, values }) => {
          return (
            <form onSubmit={handleSubmit}>
              <DialogContent>
                <Grid container spacing={2} alignItems='center'>
                  <DialogTitle>Registered Importer</DialogTitle>

                  <Grid item xs={12}>
                    <TextField
                      disabled={loading || isSubmitting}
                      error={Boolean(touched.registeredImporterNumber && errors.registeredImporterNumber)}
                      helperText={touched.registeredImporterNumber && errors.registeredImporterNumber}
                      label='Importer #'
                      name='registeredImporterNumber'
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.registeredImporterNumber}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      disabled={loading || isSubmitting}
                      error={Boolean(
                        touched.registeredImporterNhtsaRegistrationNumber && errors.registeredImporterNhtsaRegistrationNumber
                      )}
                      helperText={
                        touched.registeredImporterNhtsaRegistrationNumber && errors.registeredImporterNhtsaRegistrationNumber
                      }
                      label='NHTSA Registration #'
                      name='registeredImporterNhtsaRegistrationNumber'
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.registeredImporterNhtsaRegistrationNumber}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      disabled={loading || isSubmitting}
                      error={Boolean(touched.registeredImporterIrsNumber && errors.registeredImporterIrsNumber)}
                      helperText={touched.registeredImporterIrsNumber && errors.registeredImporterIrsNumber}
                      label='Registered Importer IRS #'
                      name='registeredImporterIrsNumber'
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.registeredImporterIrsNumber}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <ExplanationAccordion variant='outlined'>||All fields are required. ||</ExplanationAccordion>
                  </Grid>
                </Grid>
              </DialogContent>

              <DialogActions>
                <Button disabled={loading || isSubmitting} variant='text' color='inherit' onClick={onClose}>
                  CANCEL
                </Button>

                <LoadingButton loading={loading || isSubmitting} type='submit' variant='contained'>
                  SAVE
                </LoadingButton>
              </DialogActions>
            </form>
          )
        }}
      </Formik>
    </Dialog>
  )
}
